export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";